var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isLoading)?[_c('h3',[_vm._v("Loading...")])]:[_c('h3',[_vm._v(_vm._s(_vm.post.title))]),_c('p',[_vm._v(_vm._s(_vm.post.content))]),_c('router-link',{attrs:{"to":"/"}},[_vm._v("Go back home")])]],2)}
var staticRenderFns = []

export { render, staticRenderFns }